(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["sc-collection-products"] && !Shopify.designMode) return;
  try {
    
/* ── PLP filters/sort — progressive enhancement only; a plain GET <form>
   submit already applies everything with JS off. Guarded lookups throughout;
   re-inits on shopify:section:load; guards against double-init per root. */
(function () {
  'use strict';

  function initOne(root) {
    if (!root || root.__scPlpInit) return;
    root.__scPlpInit = true;

    var filters = root.querySelector('#sc-plp-filters');
    var openBtn = root.querySelector('.sc-plp-open');
    var closeBtn = root.querySelector('.sc-plp-close');
    var form = root.querySelector('#sc-plp-form');
    var desktopMq = window.matchMedia ? window.matchMedia('(min-width:1024px)') : null;

    /* The "Show results" footer is hidden on desktop in CSS, not here. Toggling
       the button's inline display from JS flashed it on first paint and left the
       empty footer strip behind it visible. */

    if (openBtn && filters) {
      openBtn.addEventListener('click', function () { filters.classList.add('on'); });
    }
    if (closeBtn && filters) {
      closeBtn.addEventListener('click', function () { filters.classList.remove('on'); });
    }

    /* A client-side "live filter" used to hide cards here by text-matching the
       brand/title in the DOM. It was removed: it only ever filtered the CURRENT
       page, so with pagination the result count and the visible products
       disagreed; it could not update the per-value counts; and it briefly hid
       the wrong cards before the real request landed.

       Filtering is Shopify's job. The form below is a plain GET that submits
       filter.* params — the server returns the correctly filtered, correctly
       counted, correctly paginated collection. Desktop submits on change,
       mobile submits via the Apply button. */
    /* "+ n more" reveals the clipped tail of a long value list. Delegated so it
       survives the section re-render Shopify performs after every filter change. */
    root.addEventListener('click', function (e) {
      var btn = e.target.closest ? e.target.closest('.filter-more') : null;
      if (!btn) return;
      e.preventDefault();
      var sec = btn.previousElementSibling;
      if (!sec || !sec.classList.contains('filter-vals')) return;
      var clipped = sec.classList.toggle('is-clipped');
      btn.setAttribute('aria-expanded', String(!clipped));
      var hidden = sec.querySelectorAll('.check.extra').length;
      btn.textContent = clipped ? '+ ' + hidden + ' more' : 'Show less';
    });

    if (form) {
      form.addEventListener('change', function (e) {
        var input = e.target;
        if (input && input.type === 'checkbox') {
          var box = input.parentElement ? input.parentElement.querySelector('.box') : null;
          if (box) box.classList.toggle('on', input.checked);
        }
        if (desktopMq && desktopMq.matches) {
          if (form.requestSubmit) form.requestSubmit();
        }
      });
    }
  }

  function bootAll(root) {
    var scope = root || document;
    if (scope.matches && scope.matches('.sc-collection-products')) { initOne(scope); return; }
    if (!scope.querySelectorAll) { scope = document; }
    scope.querySelectorAll('.sc-collection-products').forEach(initOne);
  }

  if (document.readyState !== 'loading') bootAll(document);
  else document.addEventListener('DOMContentLoaded', function () { bootAll(document); });
  document.addEventListener('shopify:section:load', function (e) { bootAll(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sc-faq"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initFaqAccordion(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('[data-sc-accordion], .sc-faq .faq').forEach(function (container) {
      if (container.dataset.scFaqInit === '1') return;
      container.dataset.scFaqInit = '1';

      var items = Array.from(container.querySelectorAll('details'));

      items.forEach(function (item) {
        var content = item.querySelector('.sc-faq-body-wrap');
        if (!content) return;

        if (item.hasAttribute('open')) {
          content.style.height = 'auto';
          content.style.opacity = '1';
          content.style.overflow = 'visible';
        } else {
          content.style.height = '0px';
          content.style.opacity = '0';
          content.style.overflow = 'hidden';
        }

        var summary = item.querySelector('summary');
        if (!summary) return;

        summary.addEventListener('click', function (e) {
          e.preventDefault();
          if (item.dataset.animating === 'true') return;

          var isOpen = item.hasAttribute('open');

          items.forEach(function (other) {
            if (other !== item && other.hasAttribute('open')) {
              closeItem(other);
            }
          });

          if (isOpen) {
            closeItem(item);
          } else {
            openItem(item);
          }
        });
      });

      function openItem(item) {
        var content = item.querySelector('.sc-faq-body-wrap');
        if (!content || item.dataset.animating === 'true') return;
        item.dataset.animating = 'true';

        item.setAttribute('open', '');
        content.style.display = 'block';
        content.style.overflow = 'hidden';
        content.style.height = '0px';
        content.style.opacity = '0';

        var targetHeight = content.scrollHeight;

        content.style.transition = 'height 0.35s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.3s ease';

        requestAnimationFrame(function () {
          content.style.height = targetHeight + 'px';
          content.style.opacity = '1';
        });

        clearTimeout(item._timer);
        item._timer = setTimeout(function () {
          content.style.height = 'auto';
          content.style.overflow = 'visible';
          delete item.dataset.animating;
        }, 360);
      }

      function closeItem(item) {
        var content = item.querySelector('.sc-faq-body-wrap');
        if (!content || item.dataset.animating === 'true') return;
        item.dataset.animating = 'true';

        var currentHeight = content.scrollHeight;
        content.style.overflow = 'hidden';
        content.style.height = currentHeight + 'px';
        content.style.opacity = '1';

        void content.offsetHeight;

        content.style.transition = 'height 0.35s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.25s ease';

        requestAnimationFrame(function () {
          content.style.height = '0px';
          content.style.opacity = '0';
        });

        clearTimeout(item._timer);
        item._timer = setTimeout(function () {
          item.removeAttribute('open');
          content.style.height = '0px';
          delete item.dataset.animating;
        }, 360);
      }
    });
  }

  if (document.readyState !== 'loading') initFaqAccordion(document);
  else document.addEventListener('DOMContentLoaded', function () { initFaqAccordion(document); });
  document.addEventListener('shopify:section:load', function (e) { initFaqAccordion(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sc-hero"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('banner-carousel')) {
  class BannerCarousel extends HTMLElement {
    constructor() {
      super();
      this.currentIndex = 0;
      this.timer = null;
      this.isPaused = false;
    }

    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('.banner-slide'));
      this.dots = Array.from(this.querySelectorAll('.banner-dot-item'));
      this.prevBtn = this.querySelector('[data-banner-prev]');
      this.nextBtn = this.querySelector('[data-banner-next]');

      if (this.slides.length <= 1) return;

      this.autoplay = this.dataset.autoplay === 'true';
      this.speed = parseInt(this.dataset.autoplaySpeed, 10) || 5000;

      this.initEvents();
      if (this.autoplay) this.startAutoplay();
    }

    initEvents() {
      this.prevBtn?.addEventListener('click', () => this.prev());
      this.nextBtn?.addEventListener('click', () => this.next());

      this.dots.forEach((dot, index) => {
        dot.addEventListener('click', () => this.goTo(index));
      });

      // Touch Swipe Gestures
      let touchStartX = 0;
      this.addEventListener('touchstart', (e) => {
        touchStartX = e.touches[0].clientX;
      }, { passive: true });

      this.addEventListener('touchend', (e) => {
        const touchEndX = e.changedTouches[0].clientX;
        const diff = touchStartX - touchEndX;
        if (Math.abs(diff) > 40) {
          if (diff > 0) this.next();
          else this.prev();
        }
      }, { passive: true });
    }

    goTo(index) {
      if (index === this.currentIndex) return;

      this.slides[this.currentIndex]?.classList.remove('is-active');
      this.dots[this.currentIndex]?.classList.remove('is-active');

      this.currentIndex = (index + this.slides.length) % this.slides.length;

      this.slides[this.currentIndex]?.classList.add('is-active');
      this.dots[this.currentIndex]?.classList.add('is-active');

      if (this.autoplay) {
        this.resetAutoplay();
      }
    }

    next() {
      this.goTo(this.currentIndex + 1);
    }

    prev() {
      this.goTo(this.currentIndex - 1);
    }

    startAutoplay() {
      this.stopAutoplay();
      this.timer = setInterval(() => {
        this.next();
      }, this.speed);
    }

    stopAutoplay() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    }

    resetAutoplay() {
      this.startAutoplay();
    }
  }

  customElements.define('banner-carousel', BannerCarousel);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sc-pdp-faq"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initAccordion(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('[data-sc-accordion], .pdp-faq-accordion').forEach(function (container) {
      if (container.dataset.scAccInit === '1') return;
      container.dataset.scAccInit = '1';

      var items = Array.from(container.querySelectorAll('details'));

      items.forEach(function (item) {
        var content = item.querySelector('.pdp-faq-body-wrap');
        if (!content) return;

        if (item.hasAttribute('open')) {
          content.style.height = 'auto';
          content.style.opacity = '1';
          content.style.overflow = 'visible';
        } else {
          content.style.height = '0px';
          content.style.opacity = '0';
          content.style.overflow = 'hidden';
        }

        var summary = item.querySelector('summary');
        if (!summary) return;

        summary.addEventListener('click', function (e) {
          e.preventDefault();
          if (item.dataset.animating === 'true') return;

          var isOpen = item.hasAttribute('open');

          items.forEach(function (other) {
            if (other !== item && other.hasAttribute('open')) {
              closeItem(other);
            }
          });

          if (isOpen) {
            closeItem(item);
          } else {
            openItem(item);
          }
        });
      });

      function openItem(item) {
        var content = item.querySelector('.pdp-faq-body-wrap');
        if (!content || item.dataset.animating === 'true') return;
        item.dataset.animating = 'true';

        item.setAttribute('open', '');
        content.style.display = 'block';
        content.style.overflow = 'hidden';
        content.style.height = '0px';
        content.style.opacity = '0';

        var targetHeight = content.scrollHeight;

        content.style.transition = 'height 0.35s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.3s ease';

        requestAnimationFrame(function () {
          content.style.height = targetHeight + 'px';
          content.style.opacity = '1';
        });

        clearTimeout(item._timer);
        item._timer = setTimeout(function () {
          content.style.height = 'auto';
          content.style.overflow = 'visible';
          delete item.dataset.animating;
        }, 360);
      }

      function closeItem(item) {
        var content = item.querySelector('.pdp-faq-body-wrap');
        if (!content || item.dataset.animating === 'true') return;
        item.dataset.animating = 'true';

        var currentHeight = content.scrollHeight;
        content.style.overflow = 'hidden';
        content.style.height = currentHeight + 'px';
        content.style.opacity = '1';

        void content.offsetHeight;

        content.style.transition = 'height 0.35s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.25s ease';

        requestAnimationFrame(function () {
          content.style.height = '0px';
          content.style.opacity = '0';
        });

        clearTimeout(item._timer);
        item._timer = setTimeout(function () {
          item.removeAttribute('open');
          content.style.height = '0px';
          delete item.dataset.animating;
        }, 360);
      }
    });
  }

  if (document.readyState !== 'loading') initAccordion(document);
  else document.addEventListener('DOMContentLoaded', function () { initAccordion(document); });
  document.addEventListener('shopify:section:load', function (e) { initAccordion(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sc-product"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initProduct(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('.sc-product').forEach(function (sec) {
      if (sec.dataset.scInit) return;
      sec.dataset.scInit = '1';

      /* gallery thumb → swap main image */
      var main = sec.querySelector('.gal-main img');
      sec.querySelectorAll('.gal-thumb[data-sc-thumb]').forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          var src = thumb.getAttribute('data-sc-thumb');
          if (main && src) main.src = src;
          sec.querySelectorAll('.gal-thumb').forEach(function (t) { t.classList.remove('gal-thumb-on'); });
          thumb.classList.add('gal-thumb-on');
        });
      });

      /* Dynamic Interactive Variant Selector Engine */
      sec.querySelectorAll('.variant').forEach(function (label) {
        label.addEventListener('click', function () {
          var group = label.closest('[data-sc-variant-group]');
          if (!group) return;

          // 1. Update visual active state
          group.querySelectorAll('.variant').forEach(function (v) {
            v.classList.remove('variant-on');
          });
          label.classList.add('variant-on');

          // Check radio input if inside label
          var radio = label.querySelector('input[type="radio"]');
          if (radio) {
            radio.checked = true;
          }

          // 2. Dynamic Price & Discount Updates
          var priceVal = radio ? radio.getAttribute('data-price') : null;
          var compareVal = radio ? radio.getAttribute('data-compare') : null;
          var saveVal = radio ? radio.getAttribute('data-save') : null;

          if (!priceVal) {
            var priceEl = label.querySelector('small[data-v-price], small');
            if (priceEl) priceVal = priceEl.textContent.trim();
          }

          if (priceVal) {
            // Update Main Price
            var mainPriceEl = sec.querySelector('.product-price-final');
            if (mainPriceEl) mainPriceEl.textContent = priceVal;

            // Update Compare Price
            var compareEl = sec.querySelector('.product-price-compare');
            if (compareEl) {
              if (compareVal && compareVal !== priceVal) {
                compareEl.textContent = compareVal;
                compareEl.hidden = false;
                compareEl.style.display = 'inline';
              }
            }

            // Update Sale Badge
            var badgeEl = sec.querySelector('.product-sale-badge');
            if (badgeEl && saveVal) {
              badgeEl.textContent = saveVal;
              badgeEl.hidden = false;
              badgeEl.style.display = 'inline-flex';
            }

            // Update Bottom Section CTA Button Price
            var ctaBtn = document.querySelector('.sc-product-cta .btn-primary');
            if (ctaBtn) {
              ctaBtn.childNodes.forEach(function(node) {
                if (node.nodeType === 3 && node.textContent.includes('Add to cart')) {
                  node.textContent = 'Add to cart — ' + priceVal + ' ';
                }
              });
            }
          }
        });
      });

      /* PDP Accordion Smooth Height Engine */
      sec.querySelectorAll('.pdp-desc-collapse').forEach(function (details) {
        var content = details.querySelector('.pdp-desc-body-wrap');
        if (!content) return;

        if (details.hasAttribute('open')) {
          content.style.height = 'auto';
          content.style.opacity = '1';
          content.style.overflow = 'visible';
        } else {
          content.style.height = '0px';
          content.style.opacity = '0';
          content.style.overflow = 'hidden';
        }

        var summary = details.querySelector('.pdp-desc-summary');
        if (!summary) return;

        summary.addEventListener('click', function (e) {
          e.preventDefault();
          if (details.dataset.animating === 'true') return;

          var isOpen = details.hasAttribute('open');
          if (isOpen) {
            closePdpItem(details);
          } else {
            openPdpItem(details);
          }
        });

        function openPdpItem(item) {
          var body = item.querySelector('.pdp-desc-body-wrap');
          if (!body || item.dataset.animating === 'true') return;
          item.dataset.animating = 'true';

          item.setAttribute('open', '');
          body.style.display = 'block';
          body.style.overflow = 'hidden';
          body.style.height = '0px';
          body.style.opacity = '0';

          var targetHeight = body.scrollHeight;

          body.style.transition = 'height 0.35s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.3s ease';

          requestAnimationFrame(function () {
            body.style.height = targetHeight + 'px';
            body.style.opacity = '1';
          });

          clearTimeout(item._timer);
          item._timer = setTimeout(function () {
            body.style.height = 'auto';
            body.style.overflow = 'visible';
            delete item.dataset.animating;
          }, 360);
        }

        function closePdpItem(item) {
          var body = item.querySelector('.pdp-desc-body-wrap');
          if (!body || item.dataset.animating === 'true') return;
          item.dataset.animating = 'true';

          var currentHeight = body.scrollHeight;
          body.style.overflow = 'hidden';
          body.style.height = currentHeight + 'px';
          body.style.opacity = '1';

          void body.offsetHeight;

          body.style.transition = 'height 0.35s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.25s ease';

          requestAnimationFrame(function () {
            body.style.height = '0px';
            body.style.opacity = '0';
          });

          clearTimeout(item._timer);
          item._timer = setTimeout(function () {
            item.removeAttribute('open');
            body.style.height = '0px';
            delete item.dataset.animating;
          }, 360);
        }
      });
    });
  }
  if (document.readyState !== 'loading') initProduct(document);
  else document.addEventListener('DOMContentLoaded', function () { initProduct(document); });
  document.addEventListener('shopify:section:load', function (e) { initProduct(e.target); });
})();

  } catch(e) { console.error(e); }
})();
})();
